import React, { Component } from 'react';
import PubSub from 'pubsub-js'
import { meshLog } from "../../../utils/spUtils";
import {SET_LIGHT_DIALOG_HIDE, SET_LIGHT_DIALOG_SHOW} from "../../../const/infoConst"
import { Select,InputNumber } from 'antd';
import './setLightDialog.less';
import close_btn from '../../../imgs/btn/close_btn.png';
import quest from "../../../imgs/item/quest.png";
import { saveWeekQuestInfo, getDaylightThresholdFc, getDaylightThresholdLux, getHoldTime, getMaxDim, getStandbyDim, getStandbyPeriod } from '../../../utils/scheduleUtils';


let q_type=0;
let q_value=0;

//设备设置界面
export default class SetLightDialog extends Component {
    constructor(a) {
        super(a);
        this.state = {
            dimLevel: 100,
            cctLevel: 3500,
            quests_arr:[{ value: 0, label: 'ON/OFF' },
                   { value: 1, label: 'Sensor Mode' },
                   { value: 2, label: 'Dim Level' },
                   { value: 3, label: 'CCT Tunable' },
                   { value: 4, label: 'Detection Area' },
                   { value: 5, label: 'Max Dim' },
                   { value: 6, label: 'HoldTime' },
                   { value: 7, label: 'Standby Dim Level' }],
                //    { value: 8, label: 'Standby Period' },
                //    { value: 9, label: 'Daylight Threshold' }
            quest_type:0,

            onoff_arr:[{ value: 0, label: 'OFF' },
                   { value: 1, label: 'ON' }],

            sensor_arr:[{ value: 0, label: 'OFF' },
                   { value: 1, label: 'ON' },
                   { value: 2, label: 'Vacant' }],       

            detection_arr:[{ value: 0, label: 'Low' },
                   { value: 1, label: 'Medium' },
                   { value: 2, label: 'High' }],

            maxdim_arr:getMaxDim(),  

            holdtime_arr:getHoldTime(),  

            standbydim_arr:getStandbyDim(),  

            standbyperiod_arr:getStandbyPeriod(), 

            thresholdLux_arr:getDaylightThresholdLux(), 
            thresholdFc_arr:getDaylightThresholdFc(), 

            threshold_arr:[{ value: 0, label: 'Lux' },
                    { value: 1, label: 'Fc' }],


        }
    }

    componentDidMount() {
        //存储新schedule后更新ui
        PubSub.subscribe("changeMeshUpdateUI", (msg, index) => {
            this.setState({ 
                // quest_type: 0
            });
        })
        PubSub.subscribe(SET_LIGHT_DIALOG_SHOW, (msg, index) => {
            this.setState({ 
                // quest_type: 0
            });
        })
    }

    //   弹窗关闭
    closeBtnClick = async () => {
        meshLog("closeBtnClick");
        PubSub.publish(SET_LIGHT_DIALOG_HIDE,'')
    }

    saveBtnClick = async () => {
        meshLog("closeBtnClick",q_type,q_value);
        saveWeekQuestInfo(q_type,q_value);
        PubSub.publish(SET_LIGHT_DIALOG_HIDE,'')
    }

    //滑动条
    handleDimChange = (key, value) => {
        this.setState({ dimLevel: value });
        meshLog('key', key, value);
        q_value=value;
    }
    handleCctChange = (key, value) => {
        this.setState({ cctLevel: value });
        meshLog('key', key, value);
        q_value=value;
    }
    //Quest选择
    handleQuestChange = (value) => {
        meshLog("Quest",value);
        q_type=value;
        this.setState({ 
            quest_type: value
        });
        if(value==0){
            q_value=0;
        }else if(value==1){
            q_value=0;
        }else if(value==2){
            q_value=100;
        }else if(value==3){
            q_value=100;
        }else if(value==4){
            q_value=2;
        }else if(value==5){
            q_value=99;
        }else if(value==6){
            q_value=0;
        }else if(value==7){
            q_value=30;
        }else if(value==8){
            q_value=2;
        }else if(value==9){
            q_value=3;
        }
    };
    // on-off
    handleChange_onoff(value){
        meshLog("onoff",value);
        q_value=value;
    }
    // sensor
    handleChange_sensor(value){
        meshLog("sensor",value);
        q_value=value;
    }
    // detection
    handleChange_detec(value){
        meshLog("detection",value);
        q_value=value;
    }
    //maxdim
    handleChange_maxdim(value){
        meshLog("maxdim",value);
        q_value=value;
    }
    //holdtime
    handleChange_holdtime(value){
        meshLog("holdtime",value);
        q_value=value;
    }
    //standbydim
    handleChange_standbydim(value){
        meshLog("standbydim",value);
        q_value=value;
    }
    //standbyperiod
    handleChange_standbyperiod(value){
        meshLog("standbyperiod",value);
        q_value=value;
    }
    //threshold_lux
    handleChange_threshold_lux(value){
        meshLog("threshold_lux",value);
        q_value=value;
    }
    //threshold
    handleChange_threshold(value){
        meshLog("threshold",value);
    }


    render() {
        const { dimLevel, cctLevel, selectedValue } = this.state;
        return (
            <div className="light_container">
                <div className="ui_grey_bg" />
                <div className="light_dialog" style={{left:(document.body.clientWidth-450)/2}}>
                    {/* 标题 */}
                    <div className="light_title">
                        <img className='icon' src={quest}/>
                        <span>Select Quest</span>
                    </div>
                    {/* 关闭按钮 */}
                    <img className='closeBtn' src={close_btn} onClick={() => { this.closeBtnClick() }}/>
                    {/* Quest选择 */}
                    <Select
                        className="quest_set_down"
                        defaultValue={this.state.quests_arr[0]}
                        onChange={this.handleQuestChange}
                        options={this.state.quests_arr}
                    />
                    {/* 类型选择 */}
                    <div className='controlBg'>
                        {/* onoff */}
                        <div className="onoff_bg" style={{ display: this.state.quest_type == 0 ? "flex" : "none" }}>
                            <span className="quest_tip"></span>
                            <Select
                                className="onoff_down"
                                defaultValue={this.state.onoff_arr[0]}
                                onChange={this.handleChange_onoff}
                                options={this.state.onoff_arr}
                            />
                        </div>

                        {/* Sensor Mode */}
                        <div className="sensor_bg" style={{ display: this.state.quest_type == 1 ? "flex" : "none" }}>
                            <span className="quest_tip"></span>
                            <Select
                                className="sensor_down"
                                defaultValue={this.state.sensor_arr[0]}
                                onChange={this.handleChange_sensor}
                                options={this.state.sensor_arr}
                            />
                        </div>


                        {/* dim */}
                        <div className="dim_bg" style={{ display: this.state.quest_type == 2 ? "flex" : "none" }}>
                            <span className="quest_tip"></span>
                            <input
                                className="dim_slider"
                                type="range"
                                min="0"
                                max="100"
                                value={dimLevel}
                                onChange={(e) => this.handleDimChange('dimLevel', parseInt(e.target.value))}
                            />
                            <InputNumber className="dim_input"
                                min={0}
                                max={100}
                                value={dimLevel}
                                readOnly={true}
                                />
                        </div>
                        {/* cct */}
                        <div className="cct_bg" style={{ display: this.state.quest_type == 3 ? "flex" : "none" }}>
                            <span className="quest_tip"></span>
                            <input
                                className="cct_slider"
                                type="range"
                                min="2700"
                                max="5700"
                                value={cctLevel}
                                onChange={(e) => this.handleCctChange('cctLevel', parseInt(e.target.value))}
                            />
                             <InputNumber className="cct_input"
                                min={2700}
                                max={5700}
                                value={cctLevel}
                                readOnly={true}
                                />
                        </div>
                        {/* Detection Area */}
                        <div className="detection_bg" style={{ display: this.state.quest_type == 4 ? "flex" : "none" }}>
                            <span className="quest_tip"></span>
                            <Select
                                className="detection_down"
                                defaultValue={this.state.detection_arr[2]}
                                onChange={this.handleChange_detec}
                                options={this.state.detection_arr}
                            />
                        </div>
                        {/* MaxDim */}
                        <div className="maxdim_bg" style={{ display: this.state.quest_type == 5 ? "flex" : "none" }}>
                            <span className="quest_tip">Valid range: 0-100%, please enter the desired value via keyboard.</span>
                            <Select
                                className="maxdim_down"
                                defaultValue={this.state.maxdim_arr[99]}
                                onChange={this.handleChange_maxdim}
                                options={this.state.maxdim_arr}
                            />
                        </div>
                        {/* HoldTime */}
                        <div className="holdtime_bg" style={{ display: this.state.quest_type == 6 ? "flex" : "none" }}>
                            <span className="quest_tip">Valid range: 5s, 30s, 1-120min, please enter the target value via keyboard.</span>
                            <Select
                                className="holdtime_down"
                                defaultValue={this.state.holdtime_arr[0]}
                                onChange={this.handleChange_holdtime}
                                options={this.state.holdtime_arr}
                            />
                        </div>
                        {/* Standby Dim Level */}
                        <div className="standbydim_bg" style={{ display: this.state.quest_type == 7 ? "flex" : "none" }}>
                            <span className="quest_tip">Valid range: 1~100%, please enter the target value via keyboard.</span>
                            <Select
                                className="standbydim_down"
                                defaultValue={this.state.standbydim_arr[4]}
                                onChange={this.handleChange_standbydim}
                                options={this.state.standbydim_arr}
                            />
                        </div>
                        {/* Standby Period */}
                        <div className="standbyperiod_bg" style={{ display: this.state.quest_type == 8 ? "flex" : "none" }}>
                            <span className="quest_tip"></span>
                            <Select
                                className="standbydim_down"
                                defaultValue={this.state.standbyperiod_arr[2]}
                                onChange={this.handleChange_standbyperiod}
                                options={this.state.standbyperiod_arr}
                            />
                        </div>
                        {/* Daylight Threshold */}
                        <div className="threshold_bg" style={{ display: this.state.quest_type == 9 ? "flex" : "none" }}>
                            <span className="quest_tip"></span>
                            <Select
                                className="threshold_lux_down"
                                defaultValue={this.state.thresholdLux_arr[3]}
                                onChange={this.handleChange_threshold_lux}
                                options={this.state.thresholdLux_arr}
                            />
                            <Select
                                className="threshold_down"
                                defaultValue={this.state.threshold_arr[0]}
                                onChange={this.handleChange_threshold}
                                options={this.state.threshold_arr}
                            />
                        </div>
                        
                    </div>
                    

                    {/* 底部按钮 */}
                    <div className="light-footer">
                        <button className='cancelBtn' onClick={() => { this.closeBtnClick() }}>Cancel</button>
                        <button className='okBtn' onClick={() => { this.saveBtnClick() }}>Confirm</button>
                    </div>
           
               
                </div>
            </div>
        );

    }
};